var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-col',{attrs:{"align":"center","justify":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}),_c('div',{staticClass:"headline ma-3 white--text"},[_vm._v(_vm._s(_vm.text || "Loading")+"...")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }